import { Exception } from './exception';

export class FormatException extends Exception {}
